// extracted by mini-css-extract-plugin
export default {"component":"rQHBb","divider":"gM9qm"};